import React from 'react'
import { Heading } from '../Heading'
import { Text } from '../Text'
import { Button } from '../Button'

export interface EmptyStateInterface {
  heading: string
  description: string
  buttonLabel?: string
  icon?: React.ReactNode
  buttonAction?: (e?: React.MouseEvent<HTMLElement>) => void
  size?: string
}

const getSize = (size: string | undefined) => {
  switch (size) {
    case 'md':
      return 'p-8'
    case 'lg':
      return 'p-16'
    default:
      return 'p-16'
  }
}

export const EmptyState = ({
  heading,
  description,
  icon,
  buttonLabel,
  buttonAction,
  size
}: EmptyStateInterface) => {
  const sizeOption = getSize(size)
  return (
    <div
      className={`bg-gray-50 border-gray-100 border rounded-tr-lg sm:rounded-t-lg lg:rounded-lg ${sizeOption}`}
    >
      <div className='text-gray-500'>{icon ? <div>{icon}</div> : ''}</div>
      <Heading size='h3' className='text-gray-500'>
        {heading}
      </Heading>
      <Text className='text-gray-500'> {description}</Text>
      {buttonLabel ? (
        <div className='mt-6'>
          <Button label={buttonLabel} onClick={buttonAction} color='primary' />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}
